import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Select } from './SharedStyles';

/**
 * Universal line-row unit picker.
 *
 * Renders nothing if:
 *   - master_units module is disabled for the company, OR
 *   - no item is selected, OR
 *   - the item has fewer than 2 units defined.
 *
 * Otherwise renders a tight <select> next to the qty cell. The parent passes
 * `onChange(unitCode)` and is responsible for applying the unit change (use
 * applyUnitChangeToLine() from unitConversion to snap unitPrice/unitCost).
 *
 * Falls back to a small read-only label showing the item's unit when the
 * picker isn't applicable — keeps the UI consistent across legacy single-unit
 * items and multi-unit items.
 */
const LineUnitPicker = ({
  item,
  line,
  onChange,
  disabled = false,
  showFallbackLabel = true,
  style
}) => {
  const { isModuleEnabled } = useAuth();
  const enabled = isModuleEnabled && isModuleEnabled('master_units');
  const itmUnits = item && Array.isArray(item.units) ? item.units : [];

  if (enabled && itmUnits.length > 1) {
    const value = (line && (line.unitCode || line.unitOfMeasure)) || '';
    return (
      <Select
        value={value}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        style={{ padding: '2px 4px', fontSize: '11px', minWidth: 56, ...(style || {}) }}
      >
        {itmUnits.map(u => (
          <option key={u.unitCode} value={u.unitCode}>{u.unitCode}</option>
        ))}
      </Select>
    );
  }

  if (showFallbackLabel && line && line.unitOfMeasure) {
    return (
      <span style={{ fontSize: '11px', color: '#64748B', whiteSpace: 'nowrap' }}>
        {line.unitOfMeasure}
      </span>
    );
  }

  return null;
};

export default LineUnitPicker;
